import axios from 'axios';
import dayjs from 'dayjs';

export enum EventType {
    /**
     * Просмотр
     */
    VIEW = 'VIEW',

    /**
     * Создание
     */
    CREATE = 'CREATE',

    /**
     * Редактирование
     */
    EDIT = 'EDIT',

    /**
     * Удаление
     */
    DELETE = 'DELETE',

    /**
     * Вход в систему
     */
    LOGIN = 'LOGIN',

    /**
     * Выход из системы
     */
    LOGOUT = 'LOGOUT',

    /**
     * Экспорт документа
     */
    EXPORT = 'EXPORT',

    /**
     * Подписание
     */
    SIGN = 'SIGN',

    /**
     * Запрос
     */
    REQUEST = 'REQUEST',

    /**
     * Импорт
     */
    IMPORT = 'IMPORT',

    /**
     * Одобрение
     */
    APPROVE = 'APPROVE',

    /**
     * Отклонение
     */
    REJECT = 'REJECT',

    /**
     * Блокировка
     */
    BLOCK = 'BLOCK',

    /**
     * Разблокировка
     */
    UNBLOCK = 'UNBLOCK',

    /**
     * Поиск
     */
    SEARCH = 'SEARCH',

    /**
     * Формирование
     */
    FORM = 'FORM',

    /**
     * Отправка
     */
    SENDING = 'SENDING',

    /**
     * Действия пользователей ППО
     */
    APP_EVENT_USER_ACTION = 'APP_EVENT_USER_ACTION',

    /**
     * Неудавшиеся действия пользователя
     */
    APP_EVENT_USER_ACTION_FAIL = 'APP_EVENT_USER_ACTION_FAIL',

    /**
     * Не указано
     */
    UNDEFINED = 'UNDEFINED',

    /**
     * Действия с учетными записями
     */
    ACCOUNT_MODIFICATION = 'ACCOUNT_MODIFICATION',

    /**
     * Получение пользователем доступа к объектам
     */
    USER_OBJECT_ACCESS = 'USER_OBJECT_ACCESS',
}

export enum EventSection {
    UNDEFINED = 'UNDEFINED',
    ADM_ACTIONS = 'ADM_ACTIONS',
    ADM_EVENTS = 'ADM_EVENTS',
}

export enum LogStatus {
    SUCCESS = "SUCCESS",
    FAILURE = "FAILURE",
    UNDEFINED = "UNDEFINED",
}

export interface LogInterface {
    eventDate: string;
    finishedDate: string;
    type: EventType;
    section: EventSection;
    status: LogStatus;
    description: string;
    endpointType: 'REST';
    payloadRequest: string;
    breadcrumbs: string;
}

export type WrapperFunction<T> = T extends Function ? Function : never;

export function logging(logData: LogInterface) {
    axios.post('/services/isnaportal/open-api/logs/log-event', logData).catch(() => {});
}

export interface LogFunctionInterface {
    config: Pick<LogInterface, 'section' | 'type' | 'description'>;
}

export interface LogFunctionInterfaceWithoutBody<Body, ResponseType> {
    body?: Body;
    wrapperFunction: () => Promise<ResponseType>;
}

export type LogFunctionType<Body, ResponseType> = (Body extends never
    ? LogFunctionInterfaceWithoutBody<Body, ResponseType>
    : LogFunctionInterfaceWithBody<Body, ResponseType>) &
    LogFunctionInterface;

export interface LogFunctionInterfaceWithBody<Body, ResponseType> {
    body: Body;
    wrapperFunction: (body: Body) => Promise<ResponseType>;
}

export const sectionViewConfig: LogFunctionInterface['config'] = {
    type: EventType.VIEW,
    section: EventSection.ADM_EVENTS,
    description: ''
};

export const sectionEditConfig: LogFunctionInterface['config'] = {
    type: EventType.EDIT,
    section: EventSection.ADM_ACTIONS,
    description: ''
};

export const sectionDeleteConfig: LogFunctionInterface['config'] = {
    type: EventType.DELETE,
    section: EventSection.ADM_ACTIONS,
    description: ''
};

export const sectionCreateConfig: LogFunctionInterface['config'] = {
    type: EventType.CREATE,
    section: EventSection.ADM_ACTIONS,
    description: ''
};

export async function logFunction<Body = any, ResponseType = any>({
                                                                      wrapperFunction,
                                                                      body,
                                                                      config,
                                                                  }: LogFunctionType<Body, ResponseType>) {
    let logData: LogInterface = {
        eventDate: '',
        finishedDate: '',
        type: EventType.VIEW,
        section: EventSection.UNDEFINED,
        status: LogStatus.SUCCESS,
        description: config.description,
        endpointType: 'REST',
        payloadRequest: '',
        breadcrumbs: localStorage.getItem('breadcrumbs'),
    };

    logData.section = config.section;
    logData.type = config.type;
    logData.payloadRequest = JSON.stringify(body);

    let result: ResponseType;

    const startDate = dayjs().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    if (typeof wrapperFunction === 'function') {
        try {
            if (body) {
                result = await (
                    wrapperFunction as LogFunctionInterfaceWithBody<
                        Body,
                        ResponseType
                        >['wrapperFunction']
                )(body);
            } else {
                result = await (
                    wrapperFunction as LogFunctionInterfaceWithoutBody<
                        Body,
                        ResponseType
                        >['wrapperFunction']
                )();
            }
        } catch (err) {
            logData.status = LogStatus.FAILURE;
        }
    }
    const endDate = dayjs().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');

    logData.eventDate = startDate;
    logData.finishedDate = endDate;
    if (logData) logging(logData);

    return result;
}
